import React from 'react'
// import ReactDOM from 'react-dom'

import { ChevronRight } from '@material-ui/icons';
//utils
// import callApi from '../../utils/callApi';

//constants
// import { SEGMENTS_LIST, ANCHOR_LIST, VINTAGE_LIST } from '../../constants/apiUrls/apiUrls'
import { MONTHS_FROM_LATEST, YEARS_FROM_LATEST, MONTHS_IN_CURRENT_YEAR_FROM_LATEST } from '../../../constants/dateConstants'

class ArchivesFilters extends React.Component {
    constructor(props) {
        super(props);
        this.currentYear = (new Date()).getFullYear();

        const selectedMonth = () => {
          return(
            this.currentYear === YEARS_FROM_LATEST[0]
            ? MONTHS_IN_CURRENT_YEAR_FROM_LATEST[0].number
            : MONTHS_FROM_LATEST[0].number
          )
        }

        this.state = {
          collapsing: {
            segment: false,
            anchor: false,
            vintage: false,
            date: false
          },
          archiveSelectedYear: YEARS_FROM_LATEST[0],
          archiveSelectedMonth: selectedMonth(),
          fullTextSearch: ''
        }
    }

    componentDidMount() {
      const { slug } = this.props;
      document.addEventListener('mousedown', this.handleClickOutside);

      if (/(\d\d\d\d\/\d\d)/.test(slug)) {
        const [ slugYear, slugMonth ] = slug.split('/');

        this.setState({
          archiveSelectedYear: slugYear,
          archiveSelectedMonth: slugMonth
        });
      }
    }

    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClick = (type) => {
      const { collapsing } = this.state;

      switch (type) {
        case "segment":
          this.setState({collapsing : {...collapsing, segment: !collapsing.segment, anchor: false, date: false, vintage: false, fullSearch: false}});
          break;
        case "anchor":
          this.setState({collapsing : {...collapsing, anchor: !collapsing.anchor, segment: false, date: false, vintage: false, fullSearch: false}});
          break;
        case "vintage":
          this.setState({collapsing : {...collapsing, vintage: !collapsing.vintage, anchor: false, segment: false, date: false, fullSearch: false}});
          break;
        case "fullSearch":
          this.setState({collapsing : {...collapsing, fullSearch: !collapsing.fullSearch, anchor: false, segment: false, date: false, vintage: false,}});
          break;
        case "date":
          this.setState({collapsing : {...collapsing, date: !collapsing.date, vintage: false, anchor: false, segment: false, fullSearch: false}});
          break;
      }
    }

    handleHrefClick = (id, type, title, e) => {
      const { setTypeOfListing, resetPageNumber } = this.props;

      e.preventDefault();

      this.handleClick(type);
      setTypeOfListing(type, id, title);
    }

    handleHrefDateClick = (type, year, month, e) => {
      const { setTypeOfListingForDate } = this.props;

      e.preventDefault();
      this.handleClick(type);
      setTypeOfListingForDate(type, year, month);
    }

    handleClickOutside = (event) => {
      const { collapsing } = this.state;

      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({collapsing : {...collapsing, segment: false, anchor: false, date: false, vintage: false, fullSearch: false}});
      }
    }

    setWrapperRef = (node) => {
      this.wrapperRef = node;
    }


    renderAnchorFilters = () => {
      const { collapsing } = this.state;
      const { anchors } = this.props;

      if (anchors.length === 0 )
        return false;

      const sortedCurrentAnchorsList = anchors.currentAnchors.filter((anchor, index) => anchors.currentAnchors.lastIndexOf(anchor) === index)
                                       .sort((a, b) => a.name < b.name ? -1 : 1);

      const sortedGuestAnchorsList = anchors.guestAnchors.filter((anchor, index) => anchors.guestAnchors.lastIndexOf(anchor) === index)
                                      .sort((a, b) => a.name < b.name ? -1 : 1);

      const sortedPastAnchorsList = anchors.pastAnchors.filter((anchor, index) => anchors.pastAnchors.lastIndexOf(anchor) === index)
                                       .sort((a, b) => a.name < b.name ? -1 : 1);

      const anchorsPerRowCount = Math.ceil(anchors.pastAnchors.length / 4);

      const filteredPastAnchorsFirstList = sortedPastAnchorsList.filter((anchor, index) => index < anchorsPerRowCount);
      const filteredPastAnchorsSecondList = sortedPastAnchorsList.filter((anchor, index) => index >= anchorsPerRowCount && index < anchorsPerRowCount * 2);
      const filteredPastAnchorsThirdList = sortedPastAnchorsList.filter((anchor, index) => index >= anchorsPerRowCount * 2 && index < anchorsPerRowCount * 3);
      const filteredPastAnchorsForthList = sortedPastAnchorsList.filter((anchor, index) => index >= anchorsPerRowCount * 3 && index < anchorsPerRowCount * 4);

      return (
        <div className={`filter-list ${(collapsing.anchor) ? '' : 'collapse'}`} id="filter-anchors">
           <div className="row-r">
              <div className="col-md-3 col-sm-3 col-xs-12">
                 <p className="h6">Current Anchors</p>
                 <ul className="list-unstyled">
                    {
                      sortedCurrentAnchorsList.map( (anchor, index) => (
                        <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                      ))
                    }
                 </ul>
              </div>
              <div className="col-md-3 col-sm-3 col-xs-12">
                 <p className="h6">Guest Anchors</p>
                 <ul className="list-unstyled">
                 {
                   sortedGuestAnchorsList.map( (anchor, index) => (
                     <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                   ))
                 }
                 </ul>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-12">
                 <p className="h6">Past Anchors</p>
                 {  filteredPastAnchorsFirstList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredPastAnchorsFirstList.map( (anchor, index) => (
                          <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredPastAnchorsSecondList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredPastAnchorsSecondList.map( (anchor, index) => (
                          <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredPastAnchorsThirdList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredPastAnchorsThirdList.map( (anchor, index) => (
                          <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredPastAnchorsForthList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredPastAnchorsForthList.map( (anchor, index) => (
                          <li key={anchor.id}><a key={anchor.id} href={`/archives?anchorid=${anchor.id}`}>{anchor.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
              </div>
           </div>
        </div>
      );
    }

    renderSegmentsFilters = () => {
      const { collapsing } = this.state;
      const { segments } = this.props;

      if (segments.length === 0 )
        return false;

      const sortedSegmentsList = segments.filter((segment, index) => segments.lastIndexOf(segment) === index)
                                         .sort((a, b) => a.name < b.name ? -1 : 1);

      const segmentsPerRowCount = Math.ceil(segments.length / 4);

      const filteredSegmentsFirstList = sortedSegmentsList.filter((segment, index) => index < segmentsPerRowCount);
      const filteredSegmentsSecondList = sortedSegmentsList.filter((segment, index) => index >= segmentsPerRowCount && index < segmentsPerRowCount * 2);
      const filteredSegmentsThirdList = sortedSegmentsList.filter((segment, index) => index >= segmentsPerRowCount * 2 && index < segmentsPerRowCount * 3);
      const filteredSegmentsForthList = sortedSegmentsList.filter((segment, index) => index >= segmentsPerRowCount * 3 && index < segmentsPerRowCount * 4);                     

      return (
        <div className={`filter-list ${(collapsing.segment) ? '' : 'collapse'}`} id="filter-segments">
           <div className="row-r">
              <div className="col-md-12 col-sm-12 col-xs-12">
              <p className="h6">
                 Available Segments
                 <small>
                 Browse your favorite segments
                 </small>
              </p>
                 {  filteredSegmentsFirstList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredSegmentsFirstList.map( (segment, index) => (
                          <li key={segment.id}><a key={segment.id} href={`/archives?segmentid=${segment.id}`}>{segment.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredSegmentsSecondList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredSegmentsSecondList.map( (segment, index) => (
                          <li key={segment.id}><a key={segment.id} href={`/archives?segmentid=${segment.id}`}>{segment.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredSegmentsThirdList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredSegmentsThirdList.map( (segment, index) => (
                          <li key={segment.id}><a key={segment.id} href={`/archives?segmentid=${segment.id}`}>{segment.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredSegmentsForthList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredSegmentsForthList.map( (segment, index) => (
                          <li key={segment.id}><a key={segment.id} href={`/archives?segmentid=${segment.id}`}>{segment.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
              </div>
           </div>
        </div>
      );
    }

    renderFullSearchFilters = () => {
      const { fullTextSearch, collapsing} = this.state;
      return (
        <div className={`filter-list ${(collapsing.fullSearch) ? '' : 'collapse'}`} id="filter-dates">
        <div className="row-r date-selection-wrapper">
           <div className='date-selection'>
             <input type="text" value={fullTextSearch} onChange={this.changeFullSearch} onKeyDown={this.handleKeyDown} placeholder="Type your word here" />
             <button onClick={this.redirectToArchiveSearch} id='view_archives_button'>
               Search
             </button>
           </div>
        </div>
     </div>);
    }

    handleKeyDown = e => {
        if(e.keyCode === 13) {
          this.redirectToArchiveSearch(e);
        }
    }

    changeFullSearch = (e) => {
      this.setState({fullTextSearch: e.target.value});
    }

    renderVintageFilters = () => {
      const { collapsing } = this.state;
      const { vintage } = this.props;
      const sortedVintageList = vintage.filter((v, index) => vintage.lastIndexOf(v) === index)
                                       .sort((a, b) => a.name < b.name ? -1 : 1);

      if (vintage.length === 0 )
        return false;

      const filteredVintageFirstList = sortedVintageList.filter((segment, index) => index < 13);
      const filteredVintageSecondList = sortedVintageList.filter((segment, index) => index >= 13);

      return (
        <div className={`filter-list ${(collapsing.vintage) ? '' : 'collapse'}`} id="filter-vintage">
           <div className="row-r">
              <div className="col-md-12 col-sm-12 col-xs-12">
                 <p className="h6">
                    Vintage Categories
                    <small>
                    old, new, and so much more
                    </small>
                 </p>
                 {  filteredVintageFirstList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredVintageFirstList.map( (vintage, index) => (
                          <li key={vintage.id}><a key={vintage.id} href={`/${vintage.slug}`}>{vintage.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
                 { filteredVintageSecondList &&
                   <div className="col-md-3 col-sm-3 col-xs-12" style={{paddingLeft: 0}}>
                      <ul className="list-unstyled">
                      {
                        filteredVintageSecondList.map( (vintage, index) => (
                          <li key={vintage.id}><a key={vintage.id} href={`/${vintage.slug}`}>{vintage.name}</a></li>
                        ))
                      }
                      </ul>
                   </div>
                 }
              </div>
           </div>
        </div>
      );
    }

    changeArchiveYear = (e) => {
      const { archiveSelectedYear, archiveSelectedMonth } = this.state;
      const isCurrentYear = (this.currentYear == e.target.value);
      const hasSelectedMonth = MONTHS_IN_CURRENT_YEAR_FROM_LATEST.find(month => month.name === archiveSelectedMonth);
      const stateParams = { archiveSelectedYear: e.target.value}

      if (isCurrentYear && !hasSelectedMonth) {
        stateParams.archiveSelectedMonth = MONTHS_IN_CURRENT_YEAR_FROM_LATEST[0].number;
      } else if (e.target.value == 2011) {
        stateParams.archiveSelectedMonth = 12;
      }
      this.setState(stateParams);
    };
    changeArchiveMonth = (e) => {
      this.setState({archiveSelectedMonth: e.target.value})
    };
    redirectToArchiveDate = (e) => {
      const { archiveSelectedYear, archiveSelectedMonth } = this.state;
      e.preventDefault();
      window.location.href = (`/${archiveSelectedYear}/${archiveSelectedMonth}`);
    }

    redirectToArchiveSearch = e => {
      e.preventDefault();
      window.location.href = (`/archives?search=${encodeURIComponent(this.state.fullTextSearch)}`);

    }

    renderDateFilters = () => {
      const { collapsing, archiveSelectedYear, archiveSelectedMonth } = this.state;

      return (
        <div className={`filter-list ${(collapsing.date) ? '' : 'collapse'}`} id="filter-dates">
           <div className="row-r date-selection-wrapper">
              <div className='date-selection'>
                <select id='select-year' value={archiveSelectedYear} onChange={this.changeArchiveYear} className='custom-select'>
                  {
                    YEARS_FROM_LATEST.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))
                  }
                </select>
                <select id='select-month' value={archiveSelectedMonth} onChange={this.changeArchiveMonth} className='custom-select'>
                  {
                  (this.currentYear == archiveSelectedYear)
                  ? (
                    MONTHS_IN_CURRENT_YEAR_FROM_LATEST.map(month => (
                     <option key={month.name} value={month.number}>{month.name}</option>
                    ))
                  ) : (
                    (archiveSelectedYear == 2011)
                    ? <option value={12}>{'December'}</option>
                    : MONTHS_FROM_LATEST.map(month => (
                     <option key={month.name} value={month.number}>{month.name}</option>
                    ))
                  )
                  }
                </select>
                <button onClick={this.redirectToArchiveDate} id='view_archives_button'>
                  VIEW
                </button>
              </div>
           </div>
        </div>
      );

      // OLD archives, shown as tables

      // return (
      //   <div className={`filter-list ${(collapsing.date) ? '' : 'collapse'}`} id="filter-dates">
      //      <div className="row-r">
      //         <div className="col-md-12 col-sm-12 col-xs-12">
      //            <p className="h6">
      //               View month
      //               <small>
      //               show all programs within a specific month
      //               </small>
      //            </p>
      //         </div>
      //         {
      //           YEARS_FROM_LATEST.map ( (year, indexYear) => (
      //             <div key={indexYear} className="col-md-2 col-sm-4 col-xs-6">
      //                <p className="h6">
      //                   {year}
      //                </p>
      //                <ul className="list-unstyled">
      //                {
      //                  MONTHS_FROM_LATEST.map( month => (
      //                    <li key={month.number}>
      //                       <a href={`/${year}/${month.number}`}>{`${month.name} ${year}`}</a>
      //                    </li>
      //                  ))
      //                }
      //                </ul>
      //             </div>
      //           ))
      //         }
      //      </div>
      //   </div>
      // );
    }

    render() {
      const { user } = this.props;
      const showSearch = (user && user.features && (user.features.indexOf('SEGMENT_SEARCH') >= 0));
      return (
        <div className="searchable-filters pagenav" id="subnav" ref={this.setWrapperRef}>
           <div className="container">
              <ul className="nav nav-tabs nav-justified">
                 <li>
                    <button className="btn btn-blank btn-block caps" onClick={this.handleClick.bind(this, "anchor")} type="button">
                    <span className="hidden-xs">Search by&nbsp;</span>
                    Anchor <ChevronRight fontSize="large" />
                    </button>
                 </li>
                 <li>
                    <button className="btn btn-blank btn-block caps" onClick={this.handleClick.bind(this, "segment")} data-listing="segment" type="button">
                    <span className="hidden-xs">Search by&nbsp;</span>
                    Segment <ChevronRight fontSize="large" />
                    </button>
                 </li>
                 <li>
                    <button className="btn btn-blank btn-block caps" onClick={this.handleClick.bind(this, "date")} data-listing="date" type="button">
                    <span className="hidden-xs">Search by&nbsp;</span>
                    Date <ChevronRight fontSize="large" />
                    </button>
                 </li>
                 {showSearch && (<li>
                    <button className="btn btn-blank btn-block caps" onClick={this.handleClick.bind(this, "fullSearch")} data-listing="fullSearch" type="button">
                    <span className="hidden-xs">Search</span>
                    <ChevronRight fontSize="large" />
                    </button>
                 </li>)}
                 <li>
                    <button className="btn btn-blank btn-block caps" onClick={this.handleClick.bind(this, "vintage")} data-listing="vintage" type="button">
                    <span className="hidden-xs">Vintage Naked&nbsp;</span>
                    News <ChevronRight fontSize="large" />
                    </button>
                 </li>
              </ul>
           </div>
           <div className="content light">
              <div className="container">
                 {this.renderAnchorFilters()}
                 {this.renderSegmentsFilters()}
                 {this.renderDateFilters()}
                 {this.renderVintageFilters()}
                 {showSearch && this.renderFullSearchFilters()}
              </div>
           </div>
        </div>
      );
    }
}
export default ArchivesFilters;
